import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from '../../util/Api';

import {
  CREATE_ASSET_SERVICE_SUCCESS,
  CREATE_COMPLAINT_BY_ASSET_SERVICE_SUCCESS,
  FETCH_ASSET_SERVICE_SUCCESS,
  GET_ASSET_SERVICE_SUCCESS,
  GET_COMPLAINT_BY_ASSET_SUCCESS,
  GET_EQUIPMENT_SUB_TYPE_DATA_SUCCESS,
  SAVE_ASSET_SERVICE_QUERY,
} from '../../constants/ActionTypes';

import axios from 'util/Api';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_ASSET_SERVICE_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_ASSET_SERVICE_QUERY,
    query,
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_ASSET_SERVICE_SUCCESS,
    data,
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_ASSET_SERVICE_SUCCESS,
    data,
  };
};

export const getComplaintByAssetSuccess = (data) => {
  return {
    type: GET_COMPLAINT_BY_ASSET_SUCCESS,
    data
  };
};

export const getEquipmentSubTypeSuccess = (data) => {
  return {
    type: GET_EQUIPMENT_SUB_TYPE_DATA_SUCCESS,
    data
  };
};

export const createComplaintSuccess = ({data}) => {
  return {
    type: CREATE_COMPLAINT_BY_ASSET_SERVICE_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { assetService } = store.getState();
      const { query } = assetService;
      const response = await axios.get(`/asset-service?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { assetService } = store.getState();
      const { query } = assetService;
      const response = await axios.get(`/asset-service/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const getComplaints = (asset) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/asset-service/getComplaintByAsset?asset=${asset}`);
      dispatch(fetchSuccess());
      dispatch(getComplaintByAssetSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getEquipmentSubType = (asset) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/asset/getEquipmentSubType?asset=${asset}`);
      dispatch(fetchSuccess());
      dispatch(getEquipmentSubTypeSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/asset-service`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({ data: response.data }));
      dispatch(fetchResource(response.data._id));
      window.location.href = `/asset-service/edit/${response.data._id}`;
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log('Error****:', error);
    }
  };
};

export const createComplaintByAssetService = (payload, assetServiceId, checkPointId) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/complaint/createByAssetServiceId?id=${assetServiceId}&indexId=${checkPointId}`, payload);
      dispatch(createComplaintSuccess(response));
      dispatch(fetchResource(assetServiceId));
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.put(`/asset-service/${id}`, payload);
      dispatch(fetchSuccess());
      history.push('/asset-service');
      dispatch(getResource());
    } catch (error) {
      console.log('Error****:', error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/asset-service/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/asset-service/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};
